import { useState } from 'react';
import cn from 'classnames';
import TradeInSlider from '@/components/tradein/TradeInSlider';
import { isTradeInAvailable } from '@/lib/trade-in';
import i18n from '@/settings/i18n';

const t = i18n.init('product');

const BeforeTradeIn = ({ className }: { className?: string }) => {
  const [showTradeIn, setShowTradeIn] = useState(false);

  if (!isTradeInAvailable()) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        id="e2e-pdp-before-trade-in"
        onClick={() => setShowTradeIn(true)}
        className={cn(
          'shrink-0 whitespace-nowrap text-xs font-medium leading-none text-gray-700 underline underline-offset-2 transition duration-150 ease-in-out hover:opacity-80 focus:outline-none',
          className,
        )}
      >
        {t`before trade-in`}
      </button>
      <TradeInSlider showModal={showTradeIn} setShowModal={setShowTradeIn} />
    </>
  );
};

export default BeforeTradeIn;
